<template>
  <Base
    :go-to-new-template-page="goToNewTemplatePage"
    :go-to-edit-template="goToEditTemplate"
    :go-to-copy-item="goToCopyItem"
    :on-delete="params => projectsService.deleteTemplates(params)"
    :on-get="params => projectsService.getFormTemplatesPage(params)"
    :on-export="false"
    :on-import="false"
    new-template-text="New Content Template"
    remove-template-text="Remove Content Template"
    :json-export-field-list="jsonExportFieldList"
  />
</template>

<script>
import Base from './base';

import { ProjectsMixin } from '../../../../mixins';

export default {
  title: 'Project-Templates',
  components: { Base },
  mixins: [ProjectsMixin],
  data() {
    return {
      jsonExportFieldList: ['description', 'fields', 'groups', 'name', 'checklistNo', 'email', 'emailCC'],
    };
  },
  methods: {
    goToNewTemplatePage() {
      this.$router.push({ name: 'new-content-template', params: { id: Math.round(Math.random() * 10000) } });
    },
    goToEditTemplate(id) {
      this.$router.push({ name: 'edit-content-template', params: { id } });
    },
    goToCopyItem(id) {
      this.$router.push({ name: 'copy-content-template', params: { id } });
    }
  }
};
</script>
